const SYNTHETIC_PENDING_ATTACHMENT_SUMMARY_PATTERN = /\n\s*\n\[Attached \d+ files?\]\s*$/i;

const toComparableUserPromptTextVariants = (value = '') => {
  const rawText = String(value || '').trim();

  if (!rawText) {
    return [];
  }

  const textWithoutSyntheticAttachmentSummary = rawText.replace(SYNTHETIC_PENDING_ATTACHMENT_SUMMARY_PATTERN, '').trim();

  return Array.from(
    new Set(
      [rawText, textWithoutSyntheticAttachmentSummary]
        .map((textValue) => {
          return String(textValue || '')
            .replace(/\s+/g, ' ')
            .trim();
        })
        .filter(Boolean)
    )
  );
};

export default toComparableUserPromptTextVariants;
